export interface BlogPostFormText {
  createTitle: string;
  editTitle: string;
  createDescription: string;
  editDescription: string;
  contentSection: string;
  title: string;
  titlePlaceholder: string;
  slugPlaceholder: string;
  excerpt: string;
  excerptPlaceholder: string;
  content: string;
  contentPlaceholder: string;
  settings: string;
  author: string;
  authorPlaceholder: string;
  featuredImage: string;
  featuredImageHint: string;
  chooseImage: string;
  removeImage: string;
  category: string;
  selectCategory: string;
  loadingCategories: string;
  categoryError: string;
  tag: string;
  selectTag: string;
  loadingTags: string;
  emptyTags: string;
  tagError: string;
  retry: string;
  status: string;
  publishNow: string;
  draftDescription: string;
  classification: string;
  hotPost: string;
  featuredPost: string;
  unsaved: string;
  cancel: string;
  saving: string;
  createPost: string;
  saveChanges: string;
  close: string;
  loadingPost: string;
}

export interface BlogPostFormLanguage {
  code: string;
  label: string;
  text: BlogPostFormText;
}

export const BLOG_POST_FORM_LANGUAGES: BlogPostFormLanguage[] = [
  {
    code: 'vi',
    label: 'Tiếng Việt',
    text: {
      createTitle: 'Thêm bài viết',
      editTitle: 'Chỉnh sửa bài viết',
      createDescription: 'Nhập nội dung và thiết lập bài viết mới',
      editDescription: 'Cập nhật nội dung và thiết lập bài viết',
      contentSection: 'Nội dung bài viết',
      title: 'Tiêu đề',
      titlePlaceholder: 'Nhập tiêu đề bài viết',
      slugPlaceholder: 'nhap-slug-bai-viet',
      excerpt: 'Đoạn trích',
      excerptPlaceholder: 'Nhập đoạn giới thiệu ngắn',
      content: 'Nội dung',
      contentPlaceholder: 'Nhập nội dung bài viết',
      settings: 'Thiết lập',
      author: 'Tên tác giả',
      authorPlaceholder: 'Nhập tên tác giả (không bắt buộc)',
      featuredImage: 'Ảnh đại diện',
      featuredImageHint: 'Ảnh hiển thị ở danh sách bài viết và ngoài trang Blog',
      chooseImage: 'Chọn ảnh',
      removeImage: 'Xóa ảnh',
      category: 'Danh mục',
      selectCategory: 'Chọn danh mục',
      loadingCategories: 'Đang tải danh mục...',
      categoryError: 'Không thể tải danh mục.',
      tag: 'Thẻ',
      selectTag: 'Chọn thẻ',
      loadingTags: 'Đang tải thẻ...',
      emptyTags: 'Chưa có thẻ nào',
      tagError: 'Không thể tải danh sách thẻ.',
      retry: 'Thử lại',
      status: 'Trạng thái',
      publishNow: 'Xuất bản ngay',
      draftDescription:
        'Bỏ chọn để lưu bài viết ở trạng thái chưa xuất bản',
      classification: 'Phân loại',
      hotPost: 'Bài viết Hot',
      featuredPost: 'Bài viết Featured',
      unsaved: 'Nội dung chưa được lưu',
      cancel: 'Hủy',
      saving: 'Đang lưu...',
      createPost: 'Lưu bài viết',
      saveChanges: 'Lưu thay đổi',
      close: 'Đóng',
      loadingPost: 'Đang tải dữ liệu bài viết...'
    }
  },
  {
    code: 'en',
    label: 'English',
    text: {
      createTitle: 'Add post',
      editTitle: 'Edit post',
      createDescription: 'Enter the content and settings for the new post',
      editDescription: 'Update the post content and settings',
      contentSection: 'Post content',
      title: 'Title',
      titlePlaceholder: 'Enter post title',
      slugPlaceholder: 'enter-post-slug',
      excerpt: 'Excerpt',
      excerptPlaceholder: 'Enter a short introduction',
      content: 'Content',
      contentPlaceholder: 'Enter post content',
      settings: 'Settings',
      author: 'Author name',
      authorPlaceholder: 'Enter author name (optional)',
      featuredImage: 'Featured image',
      featuredImageHint: 'Shown in the post list and on the public Blog pages',
      chooseImage: 'Choose image',
      removeImage: 'Remove image',
      category: 'Category',
      selectCategory: 'Select category',
      loadingCategories: 'Loading categories...',
      categoryError: 'Unable to load categories.',
      tag: 'Tags',
      selectTag: 'Select tags',
      loadingTags: 'Loading tags...',
      emptyTags: 'No tags available',
      tagError: 'Unable to load tags.',
      retry: 'Retry',
      status: 'Status',
      publishNow: 'Publish now',
      draftDescription: 'Uncheck to save the post as unpublished',
      classification: 'Classification',
      hotPost: 'Hot post',
      featuredPost: 'Featured post',
      unsaved: 'Content has not been saved',
      cancel: 'Cancel',
      saving: 'Saving...',
      createPost: 'Save post',
      saveChanges: 'Save changes',
      close: 'Close',
      loadingPost: 'Loading post data...'
    }
  },
  {
    code: 'zh',
    label: '中文',
    text: {
      createTitle: '添加文章',
      editTitle: '编辑文章',
      createDescription: '输入新文章的内容和设置',
      editDescription: '更新文章内容和设置',
      contentSection: '文章内容',
      title: '标题',
      titlePlaceholder: '输入文章标题',
      slugPlaceholder: '输入文章-slug',
      excerpt: '摘要',
      excerptPlaceholder: '输入简短摘要',
      content: '内容',
      contentPlaceholder: '输入文章内容',
      settings: '设置',
      author: '作者姓名',
      authorPlaceholder: '输入作者姓名（可选）',
      featuredImage: '封面图片',
      featuredImageHint: '显示在文章列表和 Blog 前台页面',
      chooseImage: '选择图片',
      removeImage: '删除图片',
      category: '分类',
      selectCategory: '选择分类',
      loadingCategories: '正在加载分类...',
      categoryError: '无法加载分类。',
      tag: '标签',
      selectTag: '选择标签',
      loadingTags: '正在加载标签...',
      emptyTags: '暂无标签',
      tagError: '无法加载标签列表。',
      retry: '重试',
      status: '状态',
      publishNow: '立即发布',
      draftDescription: '取消勾选以保存为未发布状态',
      classification: '文章类型',
      hotPost: '热门文章',
      featuredPost: '精选文章',
      unsaved: '内容尚未保存',
      cancel: '取消',
      saving: '正在保存...',
      createPost: '保存文章',
      saveChanges: '保存更改',
      close: '关闭',
      loadingPost: '正在加载文章数据...'
    }
  }
];
